import React, { useRef, useState, useEffect } from "react";
import "./Video.css";

const VideoIntroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.2) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className="video-intro-section">
      <div className="video-intro-container">
        {/* Video Section */}
        <div
          className={`video-section ${
            isVisible ? "fade-in-left" : ""
          }`}
        >
          <div className="video-wrapper">
            <video className="video-element" autoPlay loop muted playsInline>
              <source src="/moonvideo.mp4" type="video/mp4" alt="Moon Lounge Intro" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        {/* Text Section */}
        <div
          className={`video-description-section ${
            isVisible ? "fade-in-right" : ""
          }`}
        >
          <h2 className="video-description-title">Willkommen bei Moon Lounge</h2>
          <h1 className="video-description-text">
            Wo Tradition und Moderne aufeinandertreffen. Genieße erstklassige
            Shishas, erfrischende Drinks und ein Ambiente, das deine Sinne
            verzaubert. Ein Ort, der zum Verweilen einlädt – sei es mit Familie,
            Freunden oder bei einem besonderen Anlass.
          </h1>
        </div>
      </div>
    </div>
  );
};

export default VideoIntroSection;
